export default {
  SET_LANGUAGE_OPTIONS(state, options) {
    state.options = options;
  }
};
